import googleIcon from './google_icon.png';
import facebookIcon from './facebook_icon.png';

const icons = {
  google: googleIcon,
  facebook: facebookIcon,
};

export default icons;
